export const fabricRoutes = {
	fabricIndex: '/fabrics'
} as const
